
import { gql } from "apollo-angular";
import { environment } from "src/environments/environment";


export const GET_CATEGORIES_QUERY = (lang: string)=> gql`
{


  subCategories {
      id
      name:name_${lang}
      menu_photo
      subCategory {
          id
          name:name_${lang}
      }
  }


}
`;


export const HotDealsQuiery = gql`
 {
  offers
  {
    id
    description
    product_id
    vendor_id
    percentage
    img
    product
    {
      price
      id
      name
      photo
      description:description_ar
      rate
      rateCount
      vendor_id
    }
  }
 }`;





export const SEARCHING_ITEMS_QUERY = (lang: string)=>{

  return gql`{
    products (limit: 10 , Function: "Filters" ) {
      id
      name: name_${lang}
      photo
      brand
      {
        name: name_${lang}
      }
    }
  }`;
};



export const REQUEST_ADD_TO_CART_QUERY = gql`{

carts (Function:"Add")
{
  code
}

}`;


export const ADD_TO_CART_QUERY = gql`{

  carts (Function: "Add")
  {
    id
  }

}`;


// export const FETCH_CART_QUERY = gql`{

//   carts (Function: "Filters")
//   {
//     id
//     cart_product_specification {
//       attribute_id
//       attributes_options_id
//       attribute_options {
//         name_en
//       }
//     }
//     amount
//     price
//     product {
//       name_en
//       description_en
//       photo
//     }
//   }

// }`;


export const FETCH_CART_QUERY = (lang: string)=> gql`{

  carts (Function: "Filters")
  {
    id
    cart_product_specification {
      attribute_id
      attributes_options_id
      attribute_options {
        attributes_options{
            name: name_${lang}
        }
      }
    }
    storeAmount
    amount
    price
    product {
      name: name_${lang}
      description: description_${lang}
      photo
      brand {
        name: name_${lang}
      }
      offers {
        id
        percentage
      }
    }
  }

}`;



export const DELETE_CART_QUERY = gql`{

  carts (Function: "Delete")
  {
    id
  }

}`;


export const UPDATE_CART_QUERY = gql`{

  carts (Function: "Edit")
  {
    id
  }

}`;




export const SliderQuiery = (lang: string)=> gql`
{
  adsSpacesPositions(Function: "GetMainSliders")
  {
    id
    name
    AdsSpacesprice
    {
      id
      positions
      sliders
      {
        photo: photo_${lang}
        mobile_photo:photo_mobile_${lang}

        item_id
        vendor_id
        product {id name:name_${lang}}

        slider_seconds
      }
    }
  }
}`;

export const SubCatQuiery = (lang: string)=> gql` { subCategories(home_visibleEq:1,parentIsNull:true) {
    id
    name: name_${lang}
    photo
    vendor_id
  }
}`;



export const HomeCategoriesQuiery = (lang: string)=> gql`
  { categories(Function:"CategoryForHome" home_visible : 1){
  home_photo
  id     name:name_${lang}
  vendor_id
  products(Rand:"TRUE"){ name: name_${lang}
  discount
  photo
  id
  rate
  rateCount
  price
  }

  sub_categories (limit:5) { name:name_${lang} category_id photo
  } } }


`;

